import React, { useState } from 'react';
import { FaClock, FaEdit } from 'react-icons/fa';
import LandingPageIdeas from './LandingPageIdeas';
import AgencyRequests from './AgencyRequests';

const LandingPageSubmissions: React.FC = () => {
    const [activeTab, setActiveTab] = useState<'ideas' | 'agency'>('ideas');

    return (
        <div className="min-h-screen bg-gray-50">
            {/* Tabs */}
            <div className="bg-white border-b border-gray-200 sticky top-0 z-10">
                <div className="px-6">
                    <div className="flex space-x-1 border-b border-gray-200">
                        <button
                            onClick={() => setActiveTab('ideas')}
                            className={`px-6 py-4 font-medium text-sm border-b-2 transition-colors ${activeTab === 'ideas'
                                    ? 'border-blue-600 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            <div className="flex items-center gap-2">
                                <FaEdit />
                                <span>Founder Ideas</span>
                            </div>
                        </button>
                        <button
                            onClick={() => setActiveTab('agency')}
                            className={`px-6 py-4 font-medium text-sm border-b-2 transition-colors ${activeTab === 'agency'
                                    ? 'border-blue-600 text-blue-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`}
                        >
                            <div className="flex items-center gap-2">
                                <FaClock />
                                <span>Agency Requests</span>
                            </div>
                        </button>
                    </div>
                </div>
            </div>

            {/* Tab Content */}
            <div className="mt-6">
                {activeTab === 'ideas' ? <LandingPageIdeas /> : <AgencyRequests />}
            </div>
        </div>
    );
};

export default LandingPageSubmissions;
